module.exports = __webpack_public_path__ + "f31b1d892a19134d8231c426b3f72c0b.png";